import React from 'react';
import FeatherIcon from '../FeatherIcon';
import { FOUNDERS_PIECES, FOUNDERS_THEME } from '../../products/editions';
import { ProductImageFrame } from './shared';

/** The seven pieces of the Founder's kit, in the black-and-gold band. */
const FoundersCollection: React.FC = () => (
  <div id="founders-collection" tabIndex={-1} aria-labelledby="founders-collection-heading" role="region" className="scroll-mt-28 focus:outline-none">
    <div className="text-center max-w-3xl mx-auto">
      <h2 id="founders-collection-heading" className="text-3xl sm:text-4xl font-bold text-white">
        Inside the Founder&apos;s Collection
      </h2>
      <p className={`mt-4 text-lg ${FOUNDERS_THEME.muted}`}>
        More than a deck of cards. A limited-edition collection celebrating the people helping give pets a brighter future.
      </p>
      <p className="mt-3 text-sm text-[#a8a397]">
        Product images are concept renders; final collector packaging artwork has not been approved.
      </p>
    </div>

    <ol className="mt-12 space-y-12">
      {FOUNDERS_PIECES.map((piece, i) => (
        <li key={piece.id} className="grid gap-6 md:grid-cols-5 md:items-start border-t border-white/10 pt-10 first:border-0 first:pt-0">
          <div className={`md:col-span-2 ${i % 2 ? 'md:order-2' : ''}`}>
            <ProductImageFrame image={piece.image} label={piece.title} theme={FOUNDERS_THEME} gold aspect="aspect-[4/3]" className="bg-white/5 ring-1 ring-[#d4af37]/30" />
          </div>
          <div className="md:col-span-3">
            <p className={`text-sm font-semibold uppercase tracking-widest ${FOUNDERS_THEME.accent}`}>
              Piece {i + 1} of {FOUNDERS_PIECES.length}
            </p>
            <h3 className="mt-2 text-2xl font-bold text-white">{piece.title}</h3>
            <p className={`mt-3 ${FOUNDERS_THEME.muted}`}>{piece.summary}</p>
            <ul className={`mt-4 space-y-2 text-sm ${FOUNDERS_THEME.muted}`}>
              {piece.details.map((detail) => (
                <li key={detail} className="flex gap-2">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 rotate-45 bg-[#d4af37]" aria-hidden="true" />
                  <span>{detail}</span>
                </li>
              ))}
            </ul>
            {piece.caveat && (
              <p className="mt-4 flex gap-2 rounded-lg border border-[#d4af37]/30 bg-white/5 p-3 text-sm text-[#e9e4d6]">
                <FeatherIcon name="info" size={16} className={`mt-0.5 shrink-0 ${FOUNDERS_THEME.accent}`} />
                <span>{piece.caveat}</span>
              </p>
            )}
          </div>
        </li>
      ))}
    </ol>
  </div>
);

export default FoundersCollection;
